import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Label, MultiDataSet } from 'ng2-charts';
import { DashboardRequestsService, IBalance } from 'src/app/services/dashboard/dashboard-requests.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { UserStoreService } from 'src/app/services/user/user-store.service';
import { ModalWellcomeComponent } from '../../sections/modal-wellcome/modal-wellcome.component';
import { DialogModalSurveyService } from 'src/app/services/dialog-modal-survey/dialog-modal-survey.service';
import { Subscription, timer } from 'rxjs';
import { IDataAlertInfo, IDataRespInfo } from 'src/app/services/data/generico/generico.model';
import { ModalActualizarDatosComponent } from 'src/app/modules/private/modules/dashboard/theme/sections/modal-actualizar-datos/modal-actualizar-datos.component';
import { ModalResponseComponent } from 'src/app/theme/components/modal-response/modal-response.component';
import { ActDatosParticipeService } from 'src/app/services/data/actualizacion-datos/act-datos-participe.service';
import { IActDatosPArticipe } from 'src/app/services/data/actualizacion-datos/actualizacion-datos.model';
const appConfig = require('src/assets/configs/config.json');

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DashboardComponent implements OnInit {
  PENBalance: IBalance;
  USDBalance: IBalance;
  changeAmount: number;
  modalTimer: Subscription;
  modalShownSubscription: Subscription;
  balanceDistribution: {
    color: string;
    assetClass: string;
    porcenAssetClass: number;
    porcenAssetClassTexto: string;
    descripcionAsset: string;
  }[];
  chartValuesLabels: Label[] = [];
  chartValuesData = [];
  //
  chartPENLabels: Label[];
  chartPENValues: MultiDataSet;
  //
  chartUSDLabels: Label[];
  chartUSDValues: MultiDataSet;
  //
  chartColors = [
    {
      backgroundColor: [],
      hoverBorderColor: '#FFF',
      borderWidth: 0,
    },
  ];
  //
  chartPENColors = [
    {
      backgroundColor: [],
      hoverBorderColor: '#FFF',
      borderWidth: 0,
    },
  ];
  //
  chartUSDColors = [
    {
      backgroundColor: [],
      hoverBorderColor: '#FFF',
      borderWidth: 0,
    },
  ];

  chartOptions = {
    responsive: true,
    cutoutPercentage: 70,
    maintainAspectRatio: false,
    tooltips: {
      displayColors: false,
      callbacks: {
        label: function (tooltipItem, data) {
          return `% ${data.datasets[0]['data'][tooltipItem.index]}`;
        },
      },
    },
  };

  isMobile: boolean;

  constructor(
    public userStore: UserStoreService,
    public globalService: GlobalService,
    private storageService: StorageService,
    private dashboardRequests: DashboardRequestsService,
    private matDialog: MatDialog,
    private modalSurveyService: DialogModalSurveyService,
    private _actDatosParticipeService: ActDatosParticipeService,
  ) {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
  }

  ngOnInit() {
    // return;
    this.modalShownSubscription = this.modalSurveyService.modalShown$.subscribe((isModalShown) => {
      if (!isModalShown) {
        let surveyTimer = appConfig.modalSurveyTimer;
        this.modalTimer = timer(surveyTimer).subscribe(() => {
          this.openSurveyModal();
        });
      }
    });

    this.storageService.userProcess.subscribe((process: any) => {
      if (
        (process && this.userHaveProcess(process)) ||
        this.userStore.COGNITO_CODE === 'FIRST_SIGNIN' ||
        this.userStore.COGNITO_CODE === 'RESET_REQUIRED'
      ) {
        this.matDialog.open(ModalWellcomeComponent, {
          height: 'auto',
          width: '700px',
        });
        //
        this.userStore.COGNITO_CODE = '';
      }
    });

    const activeCUC = this.userStore.activeCUC.cuc;
    //
    this.dashboardRequests.getBalance(activeCUC, 'SOL').subscribe((apiResponse: any) => {
      this.PENBalance = apiResponse;
      const a = apiResponse.fondMut.slice(0, 3);
      const b = apiResponse.fondInv.slice(0, 2);
      const c = this.reduceFounds(apiResponse);
      const e = [...a, ...b, ...[c]].sort((x, y) => y.porcenFondo - x.porcenFondo);
      //
      this.chartPENColors[0].backgroundColor = e.map((f) => f.color);
      this.chartPENValues = e.map((f) => f.porcenFondo);
    });

    this.dashboardRequests.getBalance(activeCUC, 'DOL').subscribe((apiResponse: any) => {
      this.USDBalance = apiResponse;
      const a = apiResponse.fondMut.slice(0, 3);
      const b = apiResponse.fondInv.slice(0, 2);
      const c = this.reduceFounds(apiResponse);
      const e = [...a, ...b, ...[c]].sort((x, y) => y.porcenFondo - x.porcenFondo);
      //
      this.chartUSDColors[0].backgroundColor = e.map((f) => f.color);
      this.chartUSDValues = e.map((f) => f.porcenFondo);
    });

    this.dashboardRequests.getDistribution(activeCUC).subscribe((apiResponse: any) => {
      this.balanceDistribution = apiResponse.datos.listaAssetClass;
      this.balanceDistribution.sort((a, b) => b.porcenAssetClass - a.porcenAssetClass);
      this.chartColors[0].backgroundColor = this.balanceDistribution.map((f) => f.color);
      //
      this.changeAmount = apiResponse.datos.tipoCambio;
      this.chartValuesData = this.balanceDistribution.map((e) => e.porcenAssetClass);
    });

    this.getValidateDatosActServ(false);
  }

  userHaveProcess(process) {
    return this.userStore.document === process.userDocument && process.process === 'NEW_PASSWORD_REQUIRED';
  }

  userHaveFounds() {
    return this.havePENFounds() || this.haveUSDFounds();
  }

  haveUSDFounds() {
    return this.USDBalance ? this.USDBalance.fondos && this.USDBalance.montoTotal : false;
  }

  havePENFounds() {
    return this.PENBalance ? this.PENBalance.fondos && this.PENBalance.montoTotal : false;
  }

  reduceFounds(apiResponse) {
    return [...apiResponse.fondMut.slice(3), ...apiResponse.fondInv.slice(2)].reduce(
      (r, x) => {
        return {
          color: x.color,
          porcenFondo: r.porcenFondo + x.porcenFondo,
        };
      },
      { color: '', porcenFondo: 0 }
    );
  }

  openSurveyModal(): void {
    // let dialogRef;
    // dialogRef = this.matDialog.open(ModalSurveyComponent, {
    //   width:"500px",
    //   height: "600px",
    //   data: { getDialogRef: () => dialogRef },
    //   panelClass: 'survey-dialog-container'
    // });
    // this.modalSurveyService.setModalShown(true);
    if (this.modalTimer) {
      this.modalTimer.unsubscribe();
    }
    let url = appConfig.urlSurvey;
    let cuc = this.userStore.activeCUC.cuc;
    let device = this.isMobile ? 'MOVIL' : 'WEB';
    let host = window.location.origin;
    const rutaReemplazada = url.replace("${cuc}", cuc).replace("${device}", device).replace("${host}", host);
    let props = "staus=yes,width=" + screen.width * 0.70 + ",height=" + screen.height * 0.70 + ",top=" + ((screen.height - screen.height * 0.80) / 2) + ",left=" + ((screen.width - screen.width * 0.70) / 2);
    window.open(rutaReemplazada, "", props);
  }

  // VALIDAR MODAL ACTUALIZACION DE DATOS
  dataAlert!: IDataAlertInfo;
  dialogRefActDatos: MatDialogRef<ModalActualizarDatosComponent>;
  dialogRefResponse: MatDialogRef<ModalResponseComponent>;

  getValidateDatosActServ(isTouchBtn: boolean) {
    this._actDatosParticipeService.getActualizacionDatosParticipe(this.userStore.activeCUC.cuc).subscribe(resp => {      
      if (resp.datos && resp.datos.length) {
          if(resp.resultado && resp.resultado.subCodigo != "0"){
              this.showModalMsjErrorDataAct(false);
              this.setDataAlert(false);
          }else{
              if(isTouchBtn) {
                this.showModalDatoAct(resp.datos);
              } else {
                this.storageService.getActiveDatosAct.subscribe(showAlert => {
                  if (showAlert) this.setDataAlert(false);
                  else this.showModalDatoAct(resp.datos);
                });
              }

          } 
      }
    })
  }

  btnActualizar() {
    this.getValidateDatosActServ(true);
  }

  contador: number =0;
  showModalDatoAct(datos: IActDatosPArticipe[]) {
    document.body.style.overflowY = "hidden";
    this.dialogRefActDatos = this.matDialog.open<ModalActualizarDatosComponent,IActDatosPArticipe[]>(ModalActualizarDatosComponent, {
      panelClass: ['dialog_full_dark'],
      disableClose: true,
      autoFocus: false,
      data: datos,
    })

    this.dialogRefActDatos.afterClosed().subscribe((resp: boolean) => {
      document.body.style.overflowY = "visible";
      if(!resp) this.storageService.storeActiveDatosAct().subscribe();
      this.setDataAlert(resp);

      if(resp != null){
        let respuestaActualizacionDatos = localStorage.getItem("rpta_ad");
        if(respuestaActualizacionDatos == "-1"){
          this.contador++
          if(this.contador >=3){
              this.showModalMsjDataActGenericoReintento(false);
          }else{
            this.showModalMsjDataActGenerico(false);
          }        
        }else{
          this.showModalMsjDataAct(resp);
        }
      }
      
    });
  }

  showModalMsjDataAct(isOk: boolean) {
    if (!(isOk === true || isOk === false)) return;
    if (isOk) this.storageService.deleteActiveDatosAct().subscribe();
    this.dialogRefResponse = this.matDialog.open<ModalResponseComponent, IDataRespInfo>(ModalResponseComponent, {
      autoFocus: false,
      width: '530px',
      panelClass: ['dialog_init'],
      disableClose: true,
      data: {
        type: isOk ? 'SUCCESS' : 'ERROR',
        titleHead: isOk ? "¡Listo!" : "¡Aviso importante!",
        content: isOk ? "Tu información ingresada ha sido actualizada con éxito." : "En estos momentos no es posible realizar la actualización, ya que alguno de tus datos no cumple con las reglas de seguridad requeridas. Contáctate con el área de atención al cliente (01)572-7777 o al correo",
        content1: isOk ? null : "Servicioalcliente.fondos.pe@surainvestments.com",
        content2: null,
        btnTitle: "Entendido",
        variant: 'default',
        headerImage: 'assets/img/home/hero.png'
      }
    }) 
    this.dialogRefResponse.afterClosed().subscribe(() => {

        if(!isOk){
            const valor = localStorage.getItem("enviocorreo");
            if(valor === null || valor === undefined || valor === "N")
            this._actDatosParticipeService.enviarCorreoActDatos(this.userStore.activeCUC.cuc, this.userStore.userName).subscribe(resp => {      
                  if (resp.resultado && resp.resultado.codigo != "0") {
                      this.showModalMsjDataAct(false);
                  }else{
                     localStorage.setItem("enviocorreo","S");
                  }
            })      
        }
    });
  }

  showModalMsjDataActGenerico(isOk: boolean) {
    if (!(isOk === true || isOk === false)) return;
    if (isOk) this.storageService.deleteActiveDatosAct().subscribe();
    this.dialogRefResponse = this.matDialog.open<ModalResponseComponent, IDataRespInfo>(ModalResponseComponent, {
      autoFocus: false,
      width: '530px',
      panelClass: ['dialog_init'],
      disableClose: true,
      data: {
        type: isOk ? 'SUCCESS' : 'ERROR',
        titleHead: isOk ? "¡Listo!" : "¡Aviso importante!",
        content: isOk ? "Tu información ingresada ha sido actualizada con éxito." : "En estos momentos no es posible realizar la actualización de datos, intenta nuevamente, si el error persiste comunicate con el área de atención al cliente (01)572-7777 o al correo",
        content1: isOk ? null : "Servicioalcliente.fondos.pe@surainvestments.com",
        content2: null,
        btnTitle: "Entendido",
        variant: 'default',
        headerImage: 'assets/img/home/hero.png'
      }
    })
    
    this.dialogRefResponse.afterClosed().subscribe(() => {
      document.body.style.overflowY = "visible";
      this.getValidateDatosActServ(true);
      
    });
  }

  showModalMsjDataActGenericoReintento(isOk: boolean) {
    if (!(isOk === true || isOk === false)) return;
    if (isOk) this.storageService.deleteActiveDatosAct().subscribe();
    this.dialogRefResponse = this.matDialog.open<ModalResponseComponent, IDataRespInfo>(ModalResponseComponent, {
      autoFocus: false,
      width: '530px',
      disableClose: true,
      panelClass: ['dialog_init'],
      data: {
        type: isOk ? 'SUCCESS' : 'ERROR',
        titleHead: isOk ? "¡Listo!" : "¡Aviso importante!",
        content:  "Lo sentimos el error persiste comunícate con el área de atención al cliente (01)572-7777 o al correo",
        content1: "Servicioalcliente.fondos.pe@surainvestments.com",
        content2: null,
        btnTitle: "Entendido",
        variant: 'default',
        headerImage: 'assets/img/home/hero.png'
      }
    }) 
    this.dialogRefResponse.afterClosed().subscribe(() => {
          if(!isOk){
            const valor = localStorage.getItem("enviocorreo");
            if(valor === null || valor === undefined || valor === "N"){
              this._actDatosParticipeService.enviarCorreoActDatos(this.userStore.activeCUC.cuc, this.userStore.userName).subscribe(resp => {      
                    if (resp.resultado && resp.resultado.codigo != "0") {
                        this.showModalMsjDataActGenericoReintento(false);
                    }else{
                       localStorage.setItem("enviocorreo","S");
                    }
              })    
            }  
        }
      
    });
  }

    showModalMsjErrorDataAct(isOk: boolean) {
    this.dialogRefResponse = this.matDialog.open<ModalResponseComponent, IDataRespInfo>(ModalResponseComponent, {
      autoFocus: false,      
      width: '530px',
      panelClass: ['full-image-dialog' ],
      disableClose: true,
      data: {
        type: isOk ? 'SUCCESS' : 'ERROR',
        titleHead: "Proceso de Actualización de datos",
        content: "Queremos contarle que estamos en un proceso de actualización de sus datos personales para una mejor atención.",
        content1: "Para proceder con la actualización de sus datos, le pedimos por favor comunicarse con nuestra área de atención al cliente al (01) 572-7777 o al correo Servicioalcliente.fondos.pe@surainvestments.com",
        content2: "Muchas gracias por confiar en SURA Investments.",
        btnTitle: "Entendido",
        variant: 'full-image',
        headerImage: 'assets/img/home/hero.png'
      }
    })
    this.dialogRefResponse.afterClosed().subscribe(() => {
          if(!isOk){
            const valor = localStorage.getItem("enviocorreo");
            if(valor === null || valor === undefined || valor === "N"){
                this._actDatosParticipeService.enviarCorreoActDatos(this.userStore.activeCUC.cuc, this.userStore.userName).subscribe(resp => {      
                      if (resp.resultado && resp.resultado.codigo != "0") {
                          this.showModalMsjErrorDataAct(false);
                      }else{
                       localStorage.setItem("enviocorreo","S");
                    }
                }) 
            }     
        }
      
    });
  }

  setDataAlert(isOk: boolean) {
    this.dataAlert = {
      type: isOk ? 'SUCCESS' : 'WARN',
      titleHead: isOk ? "Importante:" : "Aviso importante:",
      content: isOk ? "Has actualizado correctamente tus datos de contacto." : "Tus datos se encuentran desactualizados.",
      btnTitle: isOk ? "" : "Actualizar"
    }
  }

  ngOnDestroy() {
    this.modalShownSubscription.unsubscribe();
    if (this.modalTimer) {
      this.modalTimer.unsubscribe();
    }
    if(this.dialogRefActDatos) this.dialogRefActDatos.close();
    if(this.dialogRefResponse) this.dialogRefResponse.close();
  }
}
